export const SET_CURRENT_USER = 'module_crm/state/auth/SET_CURRENT_USER';
export const UNSET_CURRENT_USER = 'module_crm/state/auth/UNSET_CURRENT_USER';
